import { Box } from '@chakra-ui/react';

function ListItem({ ...props }) {
    return (
        <Box
            borderStyle="solid"
            borderWidth="1px"
            borderRadius="20px"
            padding="20px"
            marginBottom="10px"
            cursor="pointer"
            transition="transform 200ms ease, border 200ms ease, box-shadow 200ms ease, -webkit-transform 200ms ease"
            _hover={{
                borderColor: 'brand.500',
                transform: 'translate(0px, -2px)',
                boxShadow: '6px 6px 0 0 #4747E6'
            }}
            {...props}
        ></Box>
    );
}

export default ListItem;
